<script setup></script>

<template>
  <h1 class="section-title">From the Sidelines to the Boardroom: My Growth Journey</h1>
  <img
    src="/images/ashley-friel-blog-post-1.jpg"
    alt="Ashley Friel Blog Post 1 Image"
    style="width: 100%; aspect-ratio: 2/1; object-fit: cover; object-position: center 10%"
    class="mt-4 w-100 rounded-4"
  />

  <h3 class="h5 mt-4 mb-0">Kicking Off My Adventure</h3>
  <p class="section-text mt-1">
    Life is an ongoing learning game, and I am always up for a new level! Be it on the field as the team's coach or in a
    classroom setting learning about business, I welcome all new challenges. Growing personally and professionally has
    been an exhilarating ride, but with every new opportunity, I step into a stronger version of me.
  </p>

  <h3 class="h5 mb-0">Breaking Out of the Comfort Zone Bubble</h3>
  <p class="section-text mt-1">
    I've always believed that nothing exciting happens inside your comfort zone. From volunteering as a soccer and
    basketball coach to leading interactive environmental lessons, each role pushed me to adapt, lead, and collaborate.
    Coaching taught me leadership and responsibility, while teaching kids showed me the joy of helping others reach
    their potential. Trust me — stepping outside the comfort zone is where the magic happens!
  </p>

  <h3 class="h5 mb-0">From Whistles to Business Suits: My Big Transition</h3>
  <p class="section-text mt-1">
    After years of playing sports, coaching, and volunteering, my passion has begun to shift more toward the business
    side of things. Now I dive into the business world while studying, networking, and chasing job opportunities. This
    may appear to be a jump from athletics to business, but I own key skills — teamwork, organization, and a
    whatever-it-takes attitude. Plus, I'm looking forward to seeing how these are going to shine in my future business
    roles!
  </p>

  <h3 class="h5 mb-0">What's Next: The Big Goals on My Horizon</h3>
  <p class="section-text mt-1 mb-0">
    To me, the future looks bright and full of opportunity, and I am ready to run with it! Pursuing roles in business,
    where my leadership and background can continue making an impact, is my goal. I love people and look forward to
    where this journey will take me in pushing myself even more.
  </p>
</template>

<style lang="scss" scoped></style>
